import React, { useContext, useEffect, useState } from 'react';
import MaisAtacado from '../Services/MaisAtacado';
import useApi from './useApi';

const UserContext = React.createContext();

const UserContextProvider = (props) => {
  const storedUser = localStorage.getItem('CurUser');
  const [user, setUser] = useState(MaisAtacado.Auth.decodeUser(storedUser));
  const [isAdmin, setIsAdmin] = useState(false);
  const [isRepre, setIsRepre] = useState(false);

  const login = useApi(MaisAtacado.Auth.login);
  const retoken = useApi(MaisAtacado.Auth.retoken);
  const logoff = useApi(MaisAtacado.Auth.logoff);
  const impersonate = useApi(MaisAtacado.Auth.impersonate);
  const suggestReset = useApi(MaisAtacado.Auth.suggestPasswordReset);
  const acceptReset = useApi(MaisAtacado.Auth.acceptPasswordReset);

  useEffect(() => {
    if (retoken.data) {
      localStorage.setItem('CurUser', retoken.data);
    }
  }, [retoken.data]);

  useEffect(() => {
    if (login.data) {
      localStorage.setItem('CurUser', login.data);
    }
  }, [login.data]);

  useEffect(() => {
    if (impersonate.data) {
      localStorage.setItem('CurUser', impersonate.data);
    }
  }, [impersonate.data]);

  useEffect(() => {
    setUser(MaisAtacado.Auth.decodeUser(storedUser));
  }, [storedUser]);

  useEffect(() => {
    if (logoff.data || logoff.error) {
      localStorage.removeItem('CurUser');
    }
  }, [logoff.data, logoff.error]);

  useEffect(() => {
    const logoffDispatch = logoff.dispatch;
    const checkExpiry = () => user && (user.exp <= new Date().getTime() / 1000) && logoffDispatch();
    checkExpiry();
    const interval = setInterval(checkExpiry, 10000);
    return () => { clearInterval(interval); };
  }, [user, logoff.dispatch]);

  useEffect(() => {
    if (user) {
      user.tipo.map(item => item === "ADMIN" && setIsAdmin(true));
    } else {
      setIsAdmin(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      user.tipo.map(item => item === "REPRE" && setIsRepre(true));
    } else {
      setIsRepre(false);
    }
  }, [user]);

  return (
    <UserContext.Provider value={{ retoken, user, login, impersonate, logoff, suggestReset, acceptReset, isAdmin, isRepre }} >
      {props.children}
    </UserContext.Provider>
  );
};

const useUser = () => {
  const { user } = useContext(UserContext);
  return user;
};

const useIsAdmin = () => {
  const { isAdmin } = useContext(UserContext);
  return isAdmin;
};

const useIsRepre = () => {
  const { isRepre } = useContext(UserContext);
  return isRepre;
};

const useAuth = () => {
  const { login, logoff, impersonate, retoken } = useContext(UserContext);
  return { login, logoff, impersonate, retoken };
};

const usePasswordReset = () => {
  const { suggestReset, acceptReset } = useContext(UserContext);
  return { suggestReset, acceptReset };
};

export { UserContextProvider, useAuth, usePasswordReset, useIsAdmin, useIsRepre };
export default useUser;
